import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import ContactPage from "@/pages/ContactPage";

export const Route = createFileRoute("/pl/contact")({
  head: () => routeHead('Kontakt z AGAPE — Umów rozmowę', META_DESCRIPTIONS.contact.pl, '/pl/contact'),
  component: ContactPage,
});
